import React from "react";
import CarouselPage from "../components/ImageCarasouel";
import BrandLogosPage from "../components/BrandLogosPage";
import CompanyHistory from "../components/CompanyHistory";
import ConnectWithUs from "../components/ConnectWithUs";

const Home = () => {
  return (
    <div className='relative'>
      {/* Corrected background image with low opacity */}
      <div
        className='absolute inset-0 w-full h-full bg-cover bg-center opacity-30 z-[-1]' // Ensure image covers full area and is behind content
      ></div>
      <p className='text-center text-md md:text-2xl font-bold text-white p-2 bg-[#1F3E8F] shadow-lg'>
        Experience the Hospitality of Aligarh’s Best Dealership
      </p>

      {/* Content */}
      <div className='text-center py-8 container mx-auto'>
        <CarouselPage />
        <BrandLogosPage />
        <CompanyHistory />
        <ConnectWithUs />
      </div>
    </div>
  );
};

export default Home;
